import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import ToggleButton from 'react-bootstrap/ToggleButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

import ECSGraph from './integrated-dashboard/Graph';
import OverallRisk from './integrated-dashboard/OverAllRisk';
import ThreatActorGeography from './integrated-dashboard/ThreatActorGeography';
import ThreatActorData from './integrated-dashboard/ThreatActorsNodegraph';
import CAPGraph from './integrated-dashboard/CAPGraph';
import RSGraph from './integrated-dashboard/RSGraph';
import ScatterGraph from './integrated-dashboard/ScatterGraph';

import { fetchThreatActorsByDomain as fetchThreatActorsByDomainService } from 'services/modules/ecs/data';

const IntegratedDashboardPage = () => {
  // Redux dispatch
  const dispatch = useDispatch();

  // Redux selectors
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData);
  const authenticatedUserContainer = useSelector((state) => state.auth.user);
  const singlecompanyContainer = useSelector((state) => state.auth.user.company)
  // State Variables
  const [radioValue, setRadioValue] = useState('1');
  const radios = [
    { name: 'Map View', value: '1' },
    { name: 'Profile View', value: '2' }
  ];

  useEffect(() => {
    if (selectedCompanyContainer) {
      const fetchThreatActorsData = async () => {
        const domain = selectedCompanyContainer.domain;
        let params = { domain: domain };
        dispatch(fetchThreatActorsByDomainService({ params }));
      };
      fetchThreatActorsData();
    }
  }, [selectedCompanyContainer, dispatch]);

  useEffect(() => {
    if (selectedCompanyContainer) {
      if (selectedCompanyContainer?.companyid === authenticatedUserContainer?.company?.id) {
        authenticatedUserContainer?.company?.applications?.forEach(element => {
        });
      } else {
        if (authenticatedUserContainer?.company?.customers?.length > 0) {
          const companyCustomers = authenticatedUserContainer.company.customers;
          const customersWithSameCompanyId = companyCustomers.filter(customer => customer.id === selectedCompanyContainer.companyid);
          if (customersWithSameCompanyId.length > 0) {
            customersWithSameCompanyId[0].applications.forEach(element => {
            });
          }
        }
      }
    }
  }, [selectedCompanyContainer, authenticatedUserContainer]);

  return (
    <div>
      <div className="row wrapper-row rounded-10">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 mb-1">
          <OverallRisk />
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 mb-1" style={{ position: 'relative' }}>
          {singlecompanyContainer?.applications?.some((app) => app.slug === "crs") ? (
            <ECSGraph chartID="gauge-one" />
          ) : (
            <>
              <ECSGraph chartID="gauge-one" />
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(6px)',
                  zIndex: 1,
                  fontSize: '1.5rem',
                  color: 'black',
                  //  fontWeight:'bold'
                }}
              >
                Subscribe to ECS
              </div>
            </>

          )}
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 mb-1" style={{ position: 'relative' }}>

          {singlecompanyContainer?.applications?.some((app) => app.slug === "vapt" || app.slug === "rhymscan") ? (
            <RSGraph chartID="gauge-one" />
          ) : (
            <>
              <RSGraph chartID="gauge-one" />
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(6px)',
                  zIndex: 1,
                  fontSize: '1.5rem',
                  color: 'black',
                  // fontWeight:'bold'
                }}
              >
                Subscribe to VAPT
              </div>
            </>
          )}
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 mb-1" style={{ position: 'relative' }}>
          {singlecompanyContainer?.applications?.some((app) => app.slug === "cap") ? (
            <CAPGraph chartID="gauge-one" />

          ) : (
            <>
              <CAPGraph chartID="gauge-one" />
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(6px)',
                  zIndex: 1,
                  fontSize: '1.5rem',
                  color: 'black',
                  //  fontWeight:'bold'
                }}
              >
                Subscribe to CAP
              </div>
            </>
          )}
        </div>
      </div>

      <div className="row wrapper-row rounded-10 integrated-dashboard-bg">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-1 integrated-dashboard-bg d-flex justify-content-end align-items-center">
          <ButtonGroup>
            {radios.map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`radio-${idx}`}
                type="radio"
                variant="outline-primary"
                name="radio"
                value={radio.value}
                checked={radioValue === radio.value}
                onChange={(e) => setRadioValue(e.currentTarget.value)}
                className="custom-toggle-button"
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </div>

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-1 integrated-dashboard-bg">
          {radioValue === '2' ? (
            <ThreatActorData height={300} />
          ) : (
            <ThreatActorGeography />
          )}
        </div>
      </div>

      <div className="row wrapper-row rounded-10">
        {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-1 integrated-dashboard-bg">
          <MitrePage />
        </div> */}
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-1 integrated-dashboard-bg">
          <ScatterGraph />
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .custom-toggle-button {
          background-color: transparent;
          border: none;
          font-weight: bold;
          color: #007bff;
        }

        .custom-toggle-button input[type="radio"] {
          display: none; /* Hide the default radio button */
        }
      `}</style>
    </div>
  );
};

export default IntegratedDashboardPage;
